<div [formGroup]="editForm"
  class="label-value-edit-modal gd-global-material-dialog-padding"
  [dir]="dir$ | async">
  <h2 class="mat-h2">{{title}}</h2>
  <div class="tw-flex tw-flex-col">

    <mat-form-field appearance="outline">
      <input matInput
        type="text"
        formControlName="label"
        autocomplete="off">
        <mat-label>{{keyLabel}}</mat-label>
        @if (editForm.get('label').hasError('required')) {
          <mat-error>
            {{keyLabel}} <span i18n>is a required field</span>
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <input matInput
          type="text"
          formControlName="value"
          autocomplete="off">
          <mat-label>{{valueLabel}}</mat-label>
          @if (fieldValueControl.dirty) {
            <mat-hint i18n>
        Changing the value of an existing field can cause data loss.
      </mat-hint>
          }
          @if (editForm.get('value').hasError('required')) {
            <mat-error>
              {{valueLabel}} <span i18n>is a required field</span>
            </mat-error>
          }
        </mat-form-field>

      </div>

      <mat-error>
        @if (editForm.hasError('duplicateItem')) {
          <ng-container i18n>
      The item with this value or label already exists!
    </ng-container>
        }
      </mat-error>

      <section class="label-value-edit-modal__section-buttons">
        <button mat-raised-button
          color="primary"
          (click)="save()"
        [disabled]="editForm.invalid || !editForm.dirty || editForm.hasError('duplicateItem')" i18n>Save</button>
        <button mat-raised-button
          color="danger"
          (click)="cancel()"
        mat-dialog-close i18n>Cancel</button>
      </section>

    </div>
